// 全体像 PDF（export スナップショット）の presigned PUT に載せる upload ID の S3 ユーザーメタデータ。
//
// presign（api）が署名対象に含めるメタデータキー・finalize（api）の HeadObject 照合キー・クライアント（web）が
// PUT で送るヘッダー名は、必ずここを唯一の正本として参照する。片方だけ文字列を変えると、presign は新キーを要求
// するのにクライアントは旧ヘッダーを送り続け、PUT が署名不一致で常時失敗 → finalize は HeadObject で必ず 404 →
// 全体像 PDF が二度と保存されない、というサイレントな全面故障になる。値レベルで一元化してドリフトを封じる。

/** S3 ユーザーメタデータのキー（`x-amz-meta-` プレフィックスを除いた部分）。presign の `Metadata` と finalize の
 * `HeadObject` 照合で使う。 */
export const EXPORT_UPLOAD_ID_METADATA_KEY = "export-upload-id";

/** クライアントが presigned PUT 時に送る S3 ユーザーメタデータのヘッダー名（presign の署名対象と一致させる）。 */
export const EXPORT_UPLOAD_ID_METADATA_HEADER = `x-amz-meta-${EXPORT_UPLOAD_ID_METADATA_KEY}`;
